import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./auth-context";

/**
 * Protected route wrapper.
 *
 * Redirects unauthenticated users to /login while preserving the
 * attempted URL in router state for post-login redirect.
 */
export function AuthGuard() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
